import type { ReactNode } from "react";

import type { DocStatus, Severity } from "../lib/api";

/** Status never relies on colour alone: every badge carries its word, and
 *  severities also carry an icon. */
const DOC_TONE: Record<DocStatus, string> = {
  draft: "neutral", issued: "info", shipped: "warning", received: "good", cancelled: "muted",
};
const DOC_LABEL: Record<DocStatus, string> = {
  draft: "Draft", issued: "Issued", shipped: "Shipped", received: "Received", cancelled: "Cancelled",
};

export function StatusBadge({ status, docType }: { status: DocStatus; docType?: string }) {
  const label = status === "shipped" && docType === "transfer_invoice" ? "In transit" : DOC_LABEL[status];
  return <span className={`badge tone-${DOC_TONE[status]}`} data-status={status}>{label}</span>;
}

const ICON: Record<Severity, string> = { error: "✕", warning: "!", info: "i" };

export function SeverityBadge({ severity }: { severity: Severity }) {
  return (
    <span className={`sev is-${severity}`}>
      <span aria-hidden="true">{ICON[severity]}</span> {severity}
    </span>
  );
}

export function SeverityIcon({ severity }: { severity: Severity }) {
  return <span className={`issue-badge is-${severity}`} aria-hidden="true">{ICON[severity]}</span>;
}

export function Pill({ children, tone = "neutral" }: { children: ReactNode; tone?: string }) {
  return <span className={`badge tone-${tone}`}>{children}</span>;
}
